import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { Partial, find } from 'lodash';
import {
    BaseControl,
    Textbox,
    TextArea,
    ColumnaMaestra,
    Container,
    Custom,
    DateTimePicker,
    ModalSelect,
    Static,
    CondicionControl
  } from '@app/shared';


@Injectable()
export class SystemUsersFormService{

  constructor() {}
  userLogin: string;

  /**
   * Formulario de tablas maestras dinamicas
   *
   * @param {*} [objectModel]
   * @returns {BaseControl<any>[]}
   * @memberof TeacherFormService
   */
  getFieldsDynamicTable(objectModel?: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'txtAlias',
        label: 'Alias de la maestra:',
        value: objectModel ? objectModel.alias : '',
        describe: 'Nota: este alias se utiliza como referencia para poder acceder a el formulario ' +
                  'y no debe llevar espacios ni caracteres especiales.',
        order: 1,
        placeholder: 'Alias del control',
        validations: {
          validators: [Validators.required, Validators.pattern('^[a-zA-Z_]*$')],
          messages: {pattern: 'Caracteres invalidos: solo letras y guiones bajos'}
        }
      }),
      new Textbox({
        key: 'txtNombre',
        label: 'Nombre:',
        order: 2,
        placeholder: 'Nombre',
        value: objectModel ? objectModel.nombre : null,
        validations: {
          validators: [Validators.required]
        }
      }),
      new TextArea({
        key: 'txtDescripcion',
        label: 'Descripción:',
        rows: '4',
        notResize: false,
        value: objectModel ? objectModel.descripcion : null,
        order: 3,
        placeholder: 'Descripción',
        validations: {
          validators: [
            Validators.required
          ]
        }
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Crea el formulario dinamico de la tabla maestra dinamica
   *
   * @param {ColumnaMaestra[]} columnsI
   * @param {*} templetesForm
   * @param {*} [data]
   * @returns {BaseControl<any>[]}
   * @memberof TeacherFormService
   */
  getFieldsDynamicTableStructure(columnsI: ColumnaMaestra[], templetesForm: any, data?: any, login: boolean = false, options?: any, requered?: any, userName?: any, generateUserLogin?: boolean): BaseControl<any>[] {   
    const columns = Static.copyObjet(columnsI) as ColumnaMaestra[];
    let controls: BaseControl<any>[] = [];

    if(!login){
      controls = [new Container({
        class: 'form-row form-check form-check-inline col-12',
        order: 1,
        controls: [
          
        ]
      })];
    }else{
      let conditionCharge: CondicionControl[] = [];
      if(options.optCharges.length){
        options.optCharges.forEach((charge: { others: any; key: any; value: any; }) => {
          if (charge.others) {
            conditionCharge.push(
              {
                campoDepende: 'cboCharge',
                siEs: 'Igual',
                valor: charge.value,
                accion: 'Mostrar'
              },
            )
          }
        })
      }
      controls = [
        new Textbox({
          key: 'txtUserName',
          type: 'text',
          label: 'Nombre de usuario:',
          placeholder: 'Ingrese el nombre de usuario para la autenticacion',
          order: 1,
          value: userName,
          readonly: generateUserLogin,
          validations: {
            validators: [Validators.required, Validators.pattern('^[a-z0-9_\-\\_\ü]+$')],
            messages: {
              pattern: 'El nombre de usuario no puede contener letras mayusculas ni caracteres especiales ' +
                       'a excepción de guiones (-) o guiones bajos (_)'
            }
          }
        }),
        new Container({
          class: 'form-row',
          order: 2,
          controls: [
            new Textbox({
              key: 'password',
              type: 'password',
              label: 'Contraseña:',
              size: 'col-12 col-lg-6',
              placeholder: 'Ingrese la contraseña',
              validations: {
                validators: [
                  Validators.required,
                  Validators.compose([
                  Validators.minLength(6),
                  Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$'),
                 ])
                ],
                messages: {
                  pattern: 'La contraseña debe tener al menos una mayúscula, una minúscula y un número'
                }
              },
            }),
            new Textbox({
              key: 'passConfirmation',
              type: 'password',
              label: 'Confirmar contraseña',
              size: 'col-12 col-lg-6',
              placeholder: 'Ingrese de nuevo la contraseña',
              validations: {
                validators: [
                  Validators.required,
                  Validators.compose([
                  Validators.minLength(6),
                  Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$'),
                 ])
                ],
                messages: {
                  pattern: 'La contraseña debe tener al menos una mayúscula, una minúscula y un número'
                }
              },
            })
          ]
        }),
        new Custom({
          key: 'cboGroups',
          label: 'Grupos:',
          template: templetesForm['multiSelect'],
          options: options ? options['optionRoles'] ? options['optionRoles'] : [] : [],
          placeholder: 'Seleccione los grupos que pertenece el usuario',
          validations: {
            validators: [Validators.required]
          },
          order: 3,
        }),
        new Container({
          class: 'form-row',
          order: 4,
          controls: [
            new Custom({
              key: 'cboCompany',
              label: 'Empresa:',
              template: templetesForm['ngSelectTpl'],
              options: options ? options['optCompanies'] ? options['optCompanies'] : [] : [],
              value: options ? options['optCompanies'] ? options['optCompanies'][0].value : null : null,
              placeholder: 'Seleccione la empresa donde pertenece el usuario',
              readonly: true,
              size: 'col-12 col-md-6',
              validations: {
                validators: [Validators.required]
              }
            }),
            new Custom({
              key: 'cboCharge',
              order: 5,
              label: 'Cargo:',
              template: templetesForm['ngSelectTpl'],
              options: options ? options['optCharges'] ? options['optCharges'] : [] : [],
              placeholder: 'Seleccione el cargo del usuario',
              size: 'col-12 col-md-6 ',
              validations: {
                validators: [Validators.required],
              },
            }),            
            new DateTimePicker({
              key: 'cboFechaInicial',
              label: 'Fecha de inicio de contrato:',
              order: 6,
              condictions : conditionCharge,
              pickerMode: 'dialog',
              pickerType: 'calendar',
              maxDate: new Date(),
              placeholder: 'Seleccione la fecha de inicio',
              size: 'col-md-6',
              validations: {
                validators: [Validators.required],
                messages: {
                  pattern: 'Este campo es necesario.'
                }
              },       
            }),
            new DateTimePicker({
              key: 'cboFechaFinal',
              label: 'Fecha de fin de contrato:',
              order: 6,
              hidden: options.others, 
              value: null,
              size: 'col-md-6',
              condictions : conditionCharge,
              pickerMode: 'dialog',
              placeholder: 'Seleccione la fecha de finalizacion',
              pickerType: 'calendar',
              validations: {
                validators: [Validators.required],
                messages: {
                  pattern: 'Este campo es necesario.'
                }
              },
            }),
            new Custom({
              key: 'cboSede',
              label: 'Dependencia:',
              template: templetesForm['ngSelectTpl'],
              options: options ? options['optSedes'] ? options['optSedes'] : [] : [],
              placeholder: 'Seleccione la sede donde pertenece el usuario',
              size: 'col-12 col-md-6',
              validations: {
                validators: [Validators.required]
              },
              condictions: [{
                campoDepende: 'cboCompany',
                siEs: 'Vacio',
                accion: 'Bloquear'
              }],
            }),
          ]
        }),
        new Container({
          class: 'form-row',
          order: 5,
          controls: [
            new Textbox({
              key: 'chActive',
              type: 'checkbox',
              label: 'Activo',
              size: 'col-12',
            }),
            new Textbox({
              key: 'chChangePassword',
              type: 'checkbox',
              value: data ? data['user_login'] ? data['user_login']['change_password'] ? data['user_login']['change_password'] : null : null : null,
              label: 'Obligar cambio de contraseña',
              size: 'col-12',
            }),
            new Custom({
              key: 'btnChangePassword',
              // template: template['tplChangePassword'],
              size: 'col-10 text-right',
            }),
          ]
        }),
      ]
    }

    if(!login){
      
      columns.forEach(field => {
        let value: any = null;
          if (data) {
            if (typeof data[field.id + ' '] !== 'undefined') {
              value = data[field.id + ' '];
            }
          }
        if (field.validaciones && field.validaciones.condiciones && field.validaciones.condiciones.length) {
          field.validaciones.condiciones.forEach(condiction => {
            const col = find(columns, {alias: condiction.campoDepende});
            if (col) {
              condiction.campoDepende = col.id + ' ';
            }
          });
        }
        const temp = {
          form: columns,
          control: field
        };
        controls[0]['controls'].push(this.getControl(field, templetesForm, value, temp));
      });
    }

    if(!login){
      controls[0]['controls'].push(
        new Textbox({
          key: 'txtUserName',
          type: 'text',
          label: 'Nombre de usuario:',
          placeholder: 'Ingrese el nombre de usuario para la autenticacion',
          size: 'col-md-12',
          value: data ? data['user_login'] ? data['user_login']['username'] ? data['user_login']['username'] : null : null : null,
          // value: userName,
          readonly: generateUserLogin,
          validations: {
            validators: [Validators.required, Validators.pattern('^[a-z0-9_\-\\_\ü]+$')],
            messages: {
              pattern: 'El nombre de usuario no puede contener letras mayusculas ni caracteres especiales ' +
                        'a excepción de guiones (-) o guiones bajos (_)'
            }
          }
        })
      );
      if (requered == true) {
        controls[0]['controls'].push(
          new Textbox({
            key: 'password',
            type: 'password',
            label: 'Contraseña:',
            size: 'col-md-6',
            value: data ? data['user_login'] ? data['user_login']['password'] ? data['user_login']['password'] : null : null : null,
            placeholder: 'Ingrese la contraseña',
            validations: {
              validators: [
                Validators.required,
                Validators.compose([
                Validators.minLength(6),
                Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$'),
               ])
              ],
              messages: {
                pattern: 'La contraseña debe tener al menos una mayúscula, una minúscula y un número'
              }

            },
          })
        );
        controls[0]['controls'].push(
          new Textbox({
            key: 'passConfirmation',
            type: 'password',
            label: 'Confirmar contraseña',
            size: 'col-md-6',
            placeholder: 'Ingrese de nuevo la contraseña',
            validations: {
              validators: [
                Validators.required,
                Validators.compose([
                Validators.minLength(6),
                Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$'),
               ])
              ],
              messages: {
                pattern: 'La contraseña debe tener al menos una mayúscula, una minúscula y un número'
              }
            },
          })
        );
      } else {
        controls[0]['controls'].push(
          new Textbox({
            key: 'password',
            type: 'password',
            label: 'Contraseña:',
            size: 'col-md-6',
            value: data ? data['user_login'] ? data['user_login']['password'] ? data['user_login']['password'] : null : null : null,
            placeholder: 'Ingrese la contraseña',
            validations: {
              validators: [
                Validators.compose([
                Validators.minLength(6),
                Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$'),
               ])
              ],
              messages: {
                pattern: 'La contraseña debe tener al menos una mayúscula, una minúscula y un número'
              }
            },
          })
        );
        controls[0]['controls'].push(
          new Textbox({
            key: 'passConfirmation',
            type: 'password',
            label: 'Confirmar contraseña',
            size: 'col-md-6',
            placeholder: 'Ingrese de nuevo la contraseña',
            validations: {
              validators: [
                Validators.compose([
                Validators.minLength(6),
                Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$'),
               ])
              ],
              messages: {
                pattern: 'La contraseña debe tener al menos una mayúscula, una minúscula y un número'
              }
            },
          })
        );
      }
      controls[0]['controls'].push(
        new Custom({
          key: 'cboGroups',
          label: 'Grupos:',
          size: 'col-md-12',
          template: templetesForm['multiSelect'],
          options: options ? options['optionRoles'] ? options['optionRoles'] : [] : [],
          value: data ? data['user_login'] ? data['user_login']['grupos'] ? data['user_login']['grupos'] : null : null : null,
          placeholder: 'Seleccione los grupos que pertenece el usuario',
          validations: {
            validators: [Validators.required]
          }
        }),
      );
      controls[0]['controls'].push(
        new Custom({
          key: 'cboCompany',
          label: 'Empresa:',
          template: templetesForm['ngSelectTpl'],
          options: options ? options['optCompanies'] ? options['optCompanies'] : [] : [],
          value: options ? options['optCompanies'] ? options['optCompanies'][0].value : null : null,
          placeholder: 'Seleccione la empresa donde pertenece el usuario',
          readonly: true,
          size: 'col-md-6',
          validations: {
            validators: [Validators.required]
          }
        }),
      );
      controls[0]['controls'].push(
        new Custom({
          key: 'cboCharge',
          label: 'Cargo:',
          template: templetesForm['ngSelectTpl'],
          options: options ? options['optCharges'] ? options['optCharges'] : [] : [],
          value: data ? data['user_login'] ? data['user_login']['cargo'] ? data['user_login']['cargo'] : null : null : null,
          placeholder: 'Seleccione el cargo del usuario',
          size: 'col-md-6 ',
          validations: {
            validators: [Validators.required],
          },
        }),
      );
      let conditionCharge: CondicionControl[] = [];
      if(options.optCharges.length){
        options.optCharges.forEach((charge: { others: any; key: any; value: any; }) => {
          if (charge.others) {
            conditionCharge.push(
              {
                campoDepende: 'cboCharge',
                siEs: 'Igual',
                valor: charge.value,
                accion: 'Mostrar'
              },
            )
          }
        })
      }
      let dateStart: Date;
      if(data){
        dateStart = new Date(data.user_login.fecha_inicial_contrato);
        dateStart.setDate(dateStart.getDate() + 1);
      }
      controls[0]['controls'].push(
        new DateTimePicker({
          key: 'cboFechaInicial',
          label: 'Fecha de inicio de contrato:',
          order: 6,
          condictions : conditionCharge,
          value: data ? data.user_login ? dateStart : null : null,
          pickerType: 'calendar',
          placeholder: 'Seleccione la fecha de inicio',
          size: 'col-md-6',
          validations: {
            validators: [Validators.required],
            messages: {
              pattern: 'Este campo es necesario.'
            }
          },             
        }),
      );
      // Se crea variable para la accion modificar la fecha sume 1 dia al datapicer
      let date2: Date;
      if (data) {
        date2 = new Date(data.user_login.fecha_final_contrato);
        date2.setDate(date2.getDate() + 1);
      }
      controls[0]['controls'].push(  
        new DateTimePicker({
          key: 'cboFechaFinal',
          label: 'Fecha de fin de contrato:',
          order: 7,
          condictions : conditionCharge,
          value: data ? data.user_login ? date2 : null : null,
          size: 'col-md-6',
          placeholder: 'Seleccione la fecha de finalizacion',
          pickerType: 'calendar',
          validations: {
            validators: [Validators.required],
            messages: {
              pattern: 'Este campo es necesario.'
            }
          },
        }),
      ),

      controls[0]['controls'].push(
        new Custom({
          key: 'cboSede',
          label: 'Dependencia:',
          order: 8,
          template: templetesForm['ngSelectTpl'],
          options: options ? options['optSedes'] ? options['optSedes'] : [] : [],
          value: data ? data['user_login'] ? data['user_login']['dependencia'] ? data['user_login']['dependencia'] : null : null : null,
          placeholder: 'Seleccione la sede donde pertenece el usuario',
          size: 'col-md-6',
          validations: {
            validators: [Validators.required]
          },
          condictions: [{
            campoDepende: 'cboCompany',
            siEs: 'Vacio',
            accion: 'Bloquear'
          }],
        }),
      );
      controls[0]['controls'].push(
        new Textbox({
          key: 'chActive',
          type: 'checkbox',
          order: 9,
          value: data ? data['user_login'] ? data['user_login']['is_active'] ? data['user_login']['is_active'] : null : null : null,
          label: 'Activo',
          size: 'col-12',
        }),
      );
      controls[0]['controls'].push(
        new Textbox({
          key: 'chChangePassword',
          type: 'checkbox',
          order: 10,
          value: data ? data['user_login'] ? data['user_login']['requerie_password'] ? data['user_login']['requerie_password'] : false : null : null,
          label: 'Obligar cambio de contraseña',
          size: 'col-12',
        }),
      );
      controls[0]['controls'].push(
        new Custom({
          key: 'btnChangePassword',
          // template: template['tplChangePassword'],
          size: 'col-10 text-right',
          order: 11,
        }),
      );
    }

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Crea el control dependiendo del tipo
   *
   * @param {ColumnaMaestra} control
   * @param {*} templetesFomr
   * @param {*} [value]
   * @param {*} [dataTemp]
   * @returns {BaseControl<Partial>}
   * @memberof TeacherFormService
   */
  getControl(
    control: ColumnaMaestra,
    templetesFomr: any,
    value?: any,
    dataTemp?: any): BaseControl<Partial> {
    let field: any;
    switch (control.tipo_campo['nombre']) {
      case 'textarea':
        const textArea: TextArea = new TextArea({
          key: control.id + ' ',
          label: control.nombre,
          size: 'col-md-' + control.espacio,
          rows: control.propiedades['rows'],
          placeholder: control.placeholder,
          value: '',
          order: control.orden + 1,
          transform: control.propiedades['transform'] ? control.propiedades['transform'] : 'ninguna',
          condictions: control.validaciones ?
                        control.validaciones.condiciones ?
                          control.validaciones.condiciones :
                        [] :
                       [],
        });
        if (control.requerido) {
          textArea.validations.validators.push(Validators.required);
        }

        if (control.propiedades['max']) {
          textArea.validations.validators.push(Validators.maxLength(control.propiedades['max']));
          textArea.validations
            .messages['maxlength'] = 'El numero máximo de caracteres es de ' + control.propiedades['max'];
        }

        if (control.propiedades['min']) {
          textArea.validations.validators.push(Validators.minLength(control.propiedades['min']));
          textArea.validations
            .messages['minlength'] = 'El numero mínimo de caracteres es de ' + control.propiedades['min'];
        }

        field = textArea;
        break;
      case 'email':
        const email: Textbox = new Textbox({
          key: control.id + ' ',
          label: control.nombre,
          type: control.tipo_campo['nombre'],
          value: '',
          order: control.orden + 1,
          placeholder: control.placeholder,
          size: 'col-md-' + control.espacio,
          validations: {
            validators: [],
            messages: {}
          },
          condictions: control.validaciones ?
                        control.validaciones.condiciones ?
                          control.validaciones.condiciones :
                        [] :
                       [],
        });
        if (control.requerido) {
          email.validations.validators.push(Validators.required);
        }

        if (control.propiedades['expresion']) {
          email.validations.validators.push(Validators.pattern(control.propiedades['expresion']));
          if (control.propiedades['mensajeExpresion']) {
            email.validations.messages['pattern'] = control.propiedades['mensajeExpresion'];
          }
        } else {
          email.validations.validators.push(Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/));
          if (control.propiedades['mensajeExpresion']) {
            email.validations.messages['pattern'] = control.propiedades['mensajeExpresion'];
          } else {
            email.validations.messages['pattern'] = 'Ingrese un email válido';
          }
        }

        field = email;
        break;
      case 'date-time-picker':
        const date: DateTimePicker = new DateTimePicker({
          key: control.id + ' ',
          label: control.nombre,
          order: control.orden + 1,
          value: null,
          size: 'col-md-' + control.espacio,
          pickerMode: 'dialog',
          placeholder: control.placeholder,
          condictions: control.validaciones ?
                        control.validaciones.condiciones ?
                          control.validaciones.condiciones :
                        [] :
                       [],
        });
        if (control.requerido) {
          date.validations.validators.push(Validators.required);
        }

        if (control.propiedades['fechaDesde']) {
          date.minDate = control.propiedades['fechaDesde'];
        }

        if (control.propiedades['fechaHasta']) {
          date.maxDate = control.propiedades['fechaHasta'];
        }

        switch (control.propiedades['tipo']) {
          case 'calendar':
            date.pickerType = 'calendar';
            break;
          case 'timer':
            date.pickerType = 'timer';
            break;
          case 'range':
            date.selectMode = 'range';
            break;
          case 'rangeTime':
            date.pickerType = 'timer';
            date.selectMode = 'range';
            break;
          case 'rangeDate':
            date.pickerType = 'calendar';
            date.selectMode = 'range';
            break;
        }
        field = date;
        break;
      case 'ngSelect':
        let valueF: any = null;
        if (control.propiedades['options'] && control.propiedades['options'].length) {
          for (const option of control.propiedades['options']) {
            if (value === option.value) {
              valueF = value;
              break;
            }
          }
        }
        let ngSelect: Custom | ModalSelect;
        if (!control.propiedades['tipoSelector'] || control.propiedades['tipoSelector'] === 'EnLista') {
          ngSelect = new Custom({
            key: control.id + ' ',
            label: control.nombre,
            order: control.orden + 1,
            size: 'col-md-' + control.espacio,
            template: templetesFomr.ngSelectTpl,
            placeholder: control.placeholder,
            value: valueF,
            options: control.propiedades['options'],
            validations: {
              validators: []
            },
            condictions: control.validaciones ?
                          control.validaciones.condiciones ?
                            control.validaciones.condiciones :
                          [] :
                          [],
          });
        } else {
          let temp = {};
          if (control.maestra_dependencia && typeof control.maestra_dependencia === 'object') {
            control.maestra_dependencia.estructura.sort((a, b) => a.orden - b.orden);
            temp = Static.copyObjet(control.maestra_dependencia);
          }
          if (dataTemp) {
            Object.keys(dataTemp).forEach(key => {
              temp[key] = dataTemp[key];
            });
          }
          ngSelect = new ModalSelect({
            key: control.id + ' ',
            label: control.nombre,
            order: control.orden + 1,
            size: 'col-md-' + control.espacio,
            placeholder: control.placeholder,
            disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
            value: valueF,
            validations: {
              validators: []
            },
            condictions: control.validaciones.condiciones,
            tmpParameter: temp,
            data: control ?
                    control.propiedades ?
                      control.propiedades['dataSelectorModal'] ?
                        control.propiedades['dataSelectorModal']
                      : []
                    : []
                  : [],
            columns: control ?
                      control.propiedades ?
                        control.propiedades['columnsSelectorModal'] ?
                          control.propiedades['columnsSelectorModal']
                        : []
                      : []
                     : [],
            keyValue: 'id',
            classModal: 'modal-lg-personalized',
            actionAdd: control ?
                        control.propiedades ?
                          control.propiedades['accionesInModal'] ?
                            control.propiedades['accionesInModal']['agregarInModal'] ?
                              control.propiedades['accionesInModal']['agregarInModal']
                            : false
                          : false
                        : false
                       : false,
            actionUpdate: control ?
                            control.propiedades ?
                              control.propiedades['accionesInModal'] ?
                                control.propiedades['accionesInModal']['modificarInModal'] ?
                                  control.propiedades['accionesInModal']['modificarInModal']
                                : false
                              : false
                            : false
                          : false,
            actionDelete: control ?
                            control.propiedades ?
                              control.propiedades['accionesInModal'] ?
                                control.propiedades['accionesInModal']['eliminarInModal'] ?
                                  control.propiedades['accionesInModal']['eliminarInModal']
                                : false
                              : false
                            : false
                          : false,
          });
        }
        if (control.requerido) {
          ngSelect.validations.validators.push(Validators.required);
        }
        field = ngSelect;
        break;
      case 'number':
        const number: Textbox = new Textbox({
          key: control.id + ' ',
          label: control.nombre,
          type: control.tipo_campo['nombre'],
          value: '',
          order: control.orden + 1,
          placeholder: control.placeholder,
          size: 'col-md-' + control.espacio,
          condictions: control.validaciones ?
                        control.validaciones.condiciones ?
                          control.validaciones.condiciones :
                        [] :
                       [],
        });
        if (control.requerido) {
          number.validations.validators.push(Validators.required);
        }

        if (control.propiedades['max']) {
          if (!control.propiedades['menorQue']) {
            number.validations.validators.push(Validators.max(control.propiedades['max']));
            number.validations.messages['max'] = 'Debe ser menor o igual a ' + control.propiedades['max'];
          } else {
            number.customMax = control.propiedades['max'];
            number.validations.messages['customMax'] = 'Debe ser menor a ' + control.propiedades['max'] + '.';
          }
        }

        if (control.propiedades['min']) {
          if (!control.propiedades['mayorQue']) {
            number.validations.validators.push(Validators.min(control.propiedades['min']));
            number.validations.messages['min'] = 'Debe ser mayor o igual a ' + control.propiedades['min'];
          } else {
            number.customMin = control.propiedades['min'];
            number.validations.messages['customMin'] = 'Debe ser mayor a ' + control.propiedades['min'] + '.';
          }
        }

        if (control.propiedades['cantidadDecimales']) {
          number.customDecimalMax = control.propiedades['cantidadDecimales'];
          number.validations.messages['customDecimalMax'] = 'Máximo ' + control.propiedades['cantidadDecimales'] +
                                                            ' decimales permitidos.';
        }

        if (!control.propiedades['enteros']) {
          if (control.propiedades['expresion']) {
            number.validations.validators.push(Validators.pattern(control.propiedades['expresion']));
            if (control.propiedades['mensajeExpresion']) {
              number.validations.messages['pattern'] = control.propiedades['mensajeExpresion'];
            }
          }
        } else {
          number.validations.validators.push(Validators.pattern(/^-?\d+$/));
          number.validations.messages['pattern'] = 'Solo numeros enteros';
        }

        field = number;
        break;
      case 'label':
        const label: Custom = new Custom({
          key: control.id + ' ',
          order: control.orden + 1,
          size: 'col-md-' + control.espacio,
          sizeFont: control.propiedades['sizeFont'],
          template: templetesFomr.labelTpl,
          hiddenLabel: true,
          label: control.nombre,
          condictions: control.validaciones ?
                        control.validaciones.condiciones ?
                          control.validaciones.condiciones :
                        [] :
                       [],
        });
        field = label;
        break;
      default:
        const text: Textbox = new Textbox({
          key: control.id + ' ',
          label: control.nombre,
          type: control.tipo_campo['nombre'],
          value: '',
          order: control.orden + 1,
          placeholder: control.placeholder,
          size: 'col-md-' + control.espacio,
          transform: control.propiedades['transform'] ? control.propiedades['transform'] : 'ninguna',
          condictions: control.validaciones ?
                        control.validaciones.condiciones ?
                          control.validaciones.condiciones :
                        [] :
                       [],
        });
        if (control.requerido) {
          text.validations.validators.push(Validators.required);
        }

        if (control.propiedades['max']) {
          text.validations.validators.push(Validators.maxLength(control.propiedades['max']));
          text.validations.messages['maxlength'] = 'El numero máximo de caracteres es de ' + control.propiedades['max'];
        }

        if (control.propiedades['min']) {
          text.validations.validators.push(Validators.minLength(control.propiedades['min']));
          text.validations.messages['minlength'] = 'El numero mínimo de caracteres es de ' + control.propiedades['min'];
        }

        if (control.propiedades['expresion']) {
          text.validations.validators.push(Validators.pattern(control.propiedades['expresion']));
          if (control.propiedades['mensajeExpresion']) {
            text.validations.messages['pattern'] = control.propiedades['mensajeExpresion'];
          }
        }

        if (
          control.propiedades['default'] &&
          control.propiedades['default'] === 'seleccionado' &&
          value === null
        ) {
          text.default = true;
        }

        field = text;
        break;
    }
    if (value && typeof control.tipo_campo === 'object' && control.tipo_campo.nombre !== 'ngSelect') {
      field['value'] = value;
    }
    return field;
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/groups-permissions/system-users/shared/system-users.form.service.ts